import React, { Suspense } from 'react';
import { CSSReset, Spinner, Center } from '@chakra-ui/react';
import react from 'react';

const Hero = React.lazy(() => import('../Components/Home/Hero'));
const Overview = React.lazy(() => import('../Components/Home/Overview'));
const VisionMission = React.lazy(() => import('../Components/Home/VisionMission'));
const Services = React.lazy(() => import('../Components/Home/Services'));
const Contact = React.lazy(() => import('../Components/Home/Contact'));
const Careers = React.lazy(() => import('../Components/Home/Careers'));
const Partners = React.lazy(() => import('../Components/Home/Partners'));
const ScrollToTopButton = React.lazy(() => import('../Components/ScrollToTopButton'));
const mainColor = "#000";

const Home = () => {
  return (
    <>
      <CSSReset />
      <Suspense fallback={
        <Center height="100vh">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color={mainColor}
            size="xl"
          />
        </Center>
      }>
          <Hero />
          <Overview />
          <VisionMission />
          <Services />

          <Partners />
                    <Careers />
          <Contact />
         <ScrollToTopButton />
      </Suspense>
    </>
  );
};

export default Home;

